import { render, staticRenderFns } from "./PlcQuoteSetting.vue?vue&type=template&id=3335ed02&scoped=true"
import script from "./PlcQuoteSetting.vue?vue&type=script&lang=js"
export * from "./PlcQuoteSetting.vue?vue&type=script&lang=js"
import style0 from "./PlcQuoteSetting.vue?vue&type=style&index=0&id=3335ed02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3335ed02",
  null
  
)

export default component.exports